var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowDropDownFilled",
    clipPath: "url(#clip0_19_132797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 14.1665L24.1666 9.99984L15.8333 5.83317L15.8333 14.1665Z",
    fill: "black",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_132797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 40,
    fill: "white",
    transform: "translate(0 20) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDownFilled);
export default __webpack_public_path__ + "static/media/ArrowDropDownFilled.dd78264b1da7ab48a40ee826bc4e382e.svg";
export { ForwardRef as ReactComponent };